import { Utils } from "@binale-tech/shared";

export const formatDefault = (v: number, precision = Utils.CurrencyUtils.CurrencyFormatter.PRECISION) =>
    Utils.CurrencyUtils.currencyFormat(v || 0, precision);
export const parseNumber = (v: string) => Number(v.replace(/\./, "").replace(/,/, "."));
export const parseSearchAmount = (v: string) => Number(v.replace(/\./g, "").replace(/,/, "."));

export const decimalFormatter = (value: number, decimal?: number) => {
    return value ? value.toFixed(decimal || 2).replace(".", ",") : "0,00";
};
